<template>
  <div>
    <!-- begin KING BED GUEST ROOM -->
    <div class="order_confirm_panel spacing">
      <div class="panel_underline_title">
        <span>{{ $t("CONFIRMATION.TITLE2") }}</span>
      </div>
      <div class="form">
        <el-row :gutter="10">
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.CHECKINDATE") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.checkInDate }}
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.CHECKOUTDATE") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.checkOutDate }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.ARRIVALTIME") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.arrivalTime }}
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.ROOMNUM") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.roomCount }}
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.NIGHT") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.nights }}
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.TRAVLERNAME") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.guestNames }}
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.EMAIL") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.guestInfo[0].contact.email }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.MOBILE") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.guestInfo[0].contact.mobile }}
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="OrderData.orderInfo.guestInfo[0].contact.showLinker">
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("MANUAL.CONTACTNAME") }}
              </div>
              <div class="lable_value_review">
                {{OrderData.orderInfo.guestInfo[0].contact.linkerInfo.name}}
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("MANUAL.CONTACTEMAIL").replace(/:$/, "") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.guestInfo[0].contact.linkerInfo.email }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("MANUAL.CONTACTMOBILE").replace(/:$/, "") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.guestInfo[0].contact.linkerInfo.mobile }}
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="OrderData.orderInfo.loyaltyId">
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("BOOKING.MEMBERSHIPCARD") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.loyaltyId }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field"></div>
              <span class="colorRed">{{
                $t("BOOKING.MEMBERSHIPCARDMSG")
              }}</span>
            </div>
          </el-col>
        </el-row>
        <!-- 成本中心 -->
        <el-row
          :gutter="10"
          v-if="
            (isCostCenterOpen || this.costCenterid > 0) && !isCostCenterEdit
          "
        >
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("BOOKING.CostCenter") }}
              </div>
              <div class="lable_value_review">
                {{ costCenterName }}
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :lg="12"
            v-if="$objBaseInfo.sourceType == 'CRM'"
          >
            <div class="grid-content">
              <div class="f-label-field"></div>
              <div class="">
                <el-button
                  v-if="isCostCenterOpen"
                  type="primary"
                  @click="CostCenterEdit"
                  class="s_btn"
                  style="height: 2.7rem; padding: 0rem 1rem"
                  >{{ $t("BOOKING.CostCenterEdit") }}</el-button
                >
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 成本中心修改 -->
        <el-row :gutter="10" v-if="isCostCenterOpen && isCostCenterEdit">
          <el-col :xs="24" :lg="12">
            <el-form>
              <el-form-item
                :label="$t('BOOKING.CostCenter')"
                class="form-label-field"
              >
                <el-select
                  v-model="costCenterid"
                  @change="CostCenterChange($event)"
                  v-el-select-loadmore="
                    CostCenterloadMore(costCenterrangeNumber)
                  "
                  filterable
                  :filter-method="filterMethod"
                  @visible-change="visibleChange"
                >
                  <el-option
                    :key="0"
                    :label="$t('MANUAL.SELECTPLACEHOLDER')"
                    :value="0"
                  ></el-option>
                  <el-option
                    v-for="item in costCenteroptions.slice(
                      0,
                      costCenterrangeNumber
                    )"
                    :key="item.id"
                    :label="getCostCenterValue(item)"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field"></div>
              <div class="">
                <el-button
                  type="primary"
                  class="s_btn"
                  @click="CostCenterEditSave()"
                  style="height: 2.7rem; padding: 0rem 1rem"
                  >{{ $t("MESSAGE.SAVE") }}</el-button
                >
                <el-button
                  type="primary"
                  @click="CostCenterEditCancel"
                  class="s_btn"
                  style="height: 2.7rem; padding: 0rem 1rem"
                  >{{ $t("MESSAGE.CONFIRMCANCELTEXT") }}</el-button
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- end KING BED GUEST ROOM -->
    <!-- begin 其他入住人信息 -->
    <div
      class="order_confirm_panel spacing"
      v-if="OrderData.orderInfo.guestInfo.length > 1"
    >
      <div class="panel_underline_title">
        <span>{{ $t("BOOKING.OTHERTITLE") }}</span>
      </div>
      <div class="form" v-for="item in OtherTravelers">
        <el-row :gutter="10">
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.TRAVLERNAME") }}
              </div>
              <div class="lable_value_review">
                {{ item.name }}
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.EMAIL") }}
              </div>
              <div class="lable_value_review">
                {{ item.contact.email }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.MOBILE") }}
              </div>
              <div class="lable_value_review">
                {{ item.contact.mobile }}
              </div>
            </div>
            <div class="colorRed">
              {{ $t("BOOKING.OTHERTITLEPROMPT") }}
            </div>
          </el-col>
          <el-col :xs="24" :lg="8" v-if="$objBaseInfo.sourceType == 'CRM'">
            <div class="grid-content">
              <div class="f-label-field">
                出生日期
              </div>
              <div class="lable_value_review">
                {{ item.birthday }}
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="item.contact.showLinker">
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("MANUAL.CONTACTNAME") }}
              </div>
              <div class="lable_value_review">
                {{item.contact.linkerInfo.name}}
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("MANUAL.CONTACTEMAIL").replace(/:$/, "") }}
              </div>
              <div class="lable_value_review">
                {{ item.contact.linkerInfo.email }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="8">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("MANUAL.CONTACTMOBILE").replace(/:$/, "") }}
              </div>
              <div class="lable_value_review">
                {{ item.contact.linkerInfo.mobile }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- end KING BED GUEST ROOM -->
    <!-- begin Booking info -->
    <div class="order_confirm_panel spacing">
      <div class="panel_underline_title">
        <span>{{ $t("CONFIRMATION.TITLE5") }}</span>
      </div>
      <div class="form">
        <el-row :gutter="10">
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.BOOKINGNAME") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.bookingAgent[0].name }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.MOBILEPHONE") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.bookingAgent[0].contact.mobile }}
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :lg="12">
            <div class="grid-content">
              <div class="f-label-field">
                {{ $t("CONFIRMATION.BOOKINFOEMAIL") }}
              </div>
              <div class="lable_value_review">
                {{ OrderData.orderInfo.bookingAgent[0].contact.email }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- end Booking info -->
  </div>
</template>


<script>
import { costcenterupdate } from "../../api/bookingData.js";
import { _debounce } from "../../utils/utils.js";
import {
  getuatp,
  getCostCenter,
  getCostCenterModel,
} from "../../api/platformData.js";
export default {
  name: "personnelInfo",
  inject: ["OrderData"],
  data: function () {
    return {
      isCostCenterOpen: false, //是否开启成本中心
      isCostCenterReq: false, //成本中心是否必填
      isCostCenterEdit: false, //是否可以修改成本中心
      isValidUATP: false, //是否验证UATP卡
      isValidExpiredUATP: false, //验证UATP卡是否过期
      costCenterType: "", //成本中心type
      CostCenterList: [], //成本中心列表
      costCenteroptions: [], //成本中心展示列表
      costCenterrangeNumber: 50, //成本中心最大展示数量
      costCenterid: 0, //成本中心id
      costCenterName: "", //成本中心名称
      uatpCardNo: "", //uatp卡号
      uatpCardValidDate: "", //uatp卡有效期
      uATPSupplierAndModel: "", //uatp卡供应商及模式
      isopenCTA:false,//是否打开CTA
    };
  },
  computed: {
    //获取成本中心下来赋值
    getCostCenterValue() {
      return (item) => {
        if (item != null && item != undefined && item != "") {
          let value = item.costName;
          if (
            item.uatpno != null &&
            item.uatpno != undefined &&
            item.uatpno != "" &&
            this.$objBaseInfo.sourceType == "CRM"
          ) {
            let uatpno = item.uatpno;
            if (uatpno.length >= 10) {
              let star = "";
              let starLength = uatpno.length - 8;
              for (let i = 0; i < starLength; i++) {
                star += "*";
              }
              // uatpno=uatpno.replace(/(?<=\d{4})\d+(?=\d{5})/,star);
              uatpno = star + uatpno.substr(uatpno.length - 8);
            } else if (uatpno.length >= 6) {
              let star = "";
              let starLength = uatpno.length - 5;
              for (let i = 0; i < starLength; i++) {
                star += "*";
              }
              uatpno = star + uatpno.substr(uatpno.length - 5);
            } else {
              let star = "";
              let starLength = uatpno.length - 2;
              for (let i = 0; i < starLength; i++) {
                star += "*";
              }
              uatpno = star + uatpno.substr(uatpno.length - 2);
            }
            value += "-" + uatpno;
          }
          return value;
        } else {
          return "";
        }
      };
    },
    OtherTravelers()//获取其他出行人信息
    {
      return this.OrderData.orderInfo.guestInfo.filter(function(item) {
        //只返回其他出行人信息
        return !item.isMajorTravelers
      })
    },
  },
  created() {

  },
  watch: {
    "OrderData.orderInfo.costCenterid"(newVal, oldVal) {
      if (oldVal!=0 && newVal != oldVal) {
        this.LoadCostCenter();
     }
    },
  },
  //存放 方法
  methods: {
    //成本中心修改按钮
    CostCenterEdit() {
      this.isCostCenterEdit = true;
    },
    //成本中心修改按钮取消
    CostCenterEditCancel() {
      this.isCostCenterEdit = false;
    },
    //成本中心保存
    CostCenterEditSave() {
      if (this.isCostCenterOpen) {
        //判断是否打开成本中心配置
        //成本中心必填的情况下判断是否有成本中心
        if (this.isCostCenterReq) {
          //判断是否存在成本中心
          if (this.CostCenterList.length == 0) {
            this.OrderData.OrderData.confirmFlag = true;
            this.confirmMsg = this.$t("BOOKING.CostCenterTitle2");
            this.OrderData.submitLoading = false;
            return;
          }

          //判断是否选择成本中心
          if (this.costCenterid == 0) {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg = this.$t("BOOKING.CostCenterTitle1");
            this.OrderData.submitLoading = false;
            return;
          }
        }
        if (this.costCenterid > 0 && this.isValidUATP) {
          //判断是否验证UATP卡卡号
          if (this.uatpCardNo == "") {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle1");
            this.OrderData.submitLoading = false;
            return;
          }
          if (!this.isopenCTA) {
            if (this.uatpCardValidDate == "") {
              //判断是否存在有效期
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle1");
              this.OrderData.submitLoading = false;
              return;
            }
            if (!this.isValidExpiredUATP) {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle2");
              this.OrderData.submitLoading = false;
              return;
            }
          }
        }
        // else {
        //   if (this.costCenterid > 0 && this.uatpCardNo != "") {
        //     if (this.uatpCardValidDate == "") {
        //       //判断是否存在有效期
        //       this.OrderData.confirmFlag = true;
        //       this.OrderData.confirmMsg = this.$t(
        //         "BOOKING.CostCenterUATPTitle1"
        //       );
        //       this.OrderData.submitLoading = false;
        //       return;
        //     }
        //   }
        // }
        this.costcenterupdate();
      }
    },
    //修改成本中心配置
    async costcenterupdate() {
      let Params = {
        BookingCode: this.OrderData.orderInfo.bookingId,
        CostCenterId: this.costCenterid,
        uatpCardNo: this.uatpCardNo,
        UatpCardValidDate: this.uatpCardValidDate,
        UATPSupplierAndModel:this.uATPSupplierAndModel,
      };
      await costcenterupdate(Params)
        .then((res) => {
          if (res.code == 200) {
            if (!res.data) {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t(
                "SERVICECHARGEINFO.SERVICECHARGEERROR"
              );
            } else {
              this.isCostCenterEdit = false;
              let costCenter_arr = this.CostCenterList.filter(
                (p) => p.id == this.costCenterid
              );
              if (costCenter_arr.length > 0) {
                this.costCenterName = costCenter_arr[0].costName;
                if (
                  costCenter_arr[0].uatpno != null &&
                  costCenter_arr[0].uatpno != undefined &&
                  costCenter_arr[0].uatpno != "" &&
                  this.$objBaseInfo.sourceType == "CRM"
                ) {
                  // this.costCenterName+="-"+costCenter_arr[0].uatpno;
                  let uatpno = costCenter_arr[0].uatpno;
                  if (uatpno.length >= 10) {
                    let star = "";
                    let starLength = uatpno.length - 8;
                    for (let i = 0; i < starLength; i++) {
                      star += "*";
                    }
                    uatpno = star + uatpno.substr(uatpno.length - 8);
                    // uatpno=uatpno.replace(/(?<=\d{4})\d+(?=\d{5})/,star);
                  } else if (uatpno.length >= 6) {
                    let star = "";
                    let starLength = uatpno.length - 5;
                    for (let i = 0; i < starLength; i++) {
                      star += "*";
                    }
                    uatpno = star + uatpno.substr(uatpno.length - 5);
                  } else {
                    let star = "";
                    let starLength = uatpno.length - 2;
                    for (let i = 0; i < starLength; i++) {
                      star += "*";
                    }
                    uatpno = star + uatpno.substr(uatpno.length - 2);
                  }
                  this.costCenterName += "-" + uatpno;
                }
              }
            }
          } else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg = this.$t(
              "SERVICECHARGEINFO.SERVICECHARGEERROR"
            );
          }
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    //加载成本中心
    LoadCostCenter() {
      //判断是否存在成本中心配置
      if (
        Object.prototype.hasOwnProperty.call(
          this.$objBaseInfo,
          "posCostCenterModel"
        )
      ) {
        let posCostCenterModel = this.$objBaseInfo.posCostCenterModel;
        if (
          posCostCenterModel == undefined ||
          posCostCenterModel == null ||
          posCostCenterModel == ""
        ) {
          return;
        }
        this.costCenterType = posCostCenterModel.selectedtype;
        if (posCostCenterModel.isopen == 1) {
          this.isCostCenterOpen = true;
        }
        if (this.isCostCenterOpen && posCostCenterModel.isreq == 1) {
          this.isCostCenterReq = true;
        }
        if (this.OrderData.orderInfo.costCenterid > 0) {
          this.costCenterid = this.OrderData.orderInfo.costCenterid;
          this.uatpCardNo = this.OrderData.orderInfo.paymentInfo.airplusUatp;
          this.uatpCardValidDate =
            this.OrderData.orderInfo.paymentInfo.airplusUatpvalidYearMonth;
          this.uATPSupplierAndModel =
            this.OrderData.orderInfo.paymentInfo.uATPSupplierAndModel;
          this.getCostCenterModel();
        }
        if (this.isCostCenterOpen) {
          if (this.$objBaseInfo.sourceType == "CRM" && this.isCostCenterOpen) {
            this.GetCostCenterList(); //获取成本中心列表
          }
        }
        if (posCostCenterModel.isuatp == 1) {
          this.isValidUATP = true;
          this.isValidExpiredUATP = false;
        } else {
          this.isValidUATP = false;
        }
      }
    },
    //获取UATP卡详情
    GetUATPDetails() {
      if(this.$objBaseInfo.posCostCenterModel.isOpenJICTA|| this.$objBaseInfo.posCostCenterModel.isOpenGATCTA || this.$objBaseInfo.posCostCenterModel.isOpenJDCTA)
      {
        this.isopenCTA=true;
        return;
      }
      let Params = {
        params: {
          cradNo: this.uatpCardNo,
          userCode:this.$objBaseInfo.customerCode,
        },
      };
      let that = this;
      getuatp(Params)
        .then((res) => {
          if (res.code == 200) {
            let date = that.toValidate(res.data.expirationDate);
            const now = new Date();
            const monthStartDate = new Date(now.getFullYear(), now.getMonth(), 1);
            if (new Date(date) < monthStartDate) {
              if (that.isValidUATP) {
                that.confirmFlag = true;
                that.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle2");
                that.isValidExpiredUATP = false;
              } else {
                that.uatpCardValidDate = res.data.expirationDate;
                that.uATPSupplierAndModel=res.data.supplierAndModel;
              }
            } else {
              that.uatpCardValidDate = res.data.expirationDate;
              that.uATPSupplierAndModel=res.data.supplierAndModel;
              that.isValidExpiredUATP = true;
            }
          } else {
            if (that.isValidUATP) {
              that.confirmFlag = true;
              that.confirmMsg = this.$t("BOOKING.CostCenterUATPTitle1");
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //获取成本中心model
    getCostCenterModel() {
      let Params = {
        params: {
          id: this.costCenterid,
        },
      };
      let that = this;
      getCostCenterModel(Params)
        .then((res) => {
          if (res.code == 200) {
            that.costCenterName = res.data.costName;
            if (
              res.data.uatpno != null &&
              res.data.uatpno != undefined &&
              res.data.uatpno != "" &&
              this.$objBaseInfo.sourceType == "CRM"
            ) {
              let uatpno = res.data.uatpno;
              if (uatpno.length >= 10) {
                let star = "";
                let starLength = uatpno.length - 8;
                for (let i = 0; i < starLength; i++) {
                  star += "*";
                }
                uatpno = star + uatpno.substr(uatpno.length - 8);
                // uatpno=uatpno.replace(/(?<=\d{4})\d+(?=\d{5})/,star);
              } else if (uatpno.length >= 6) {
                let star = "";
                let starLength = uatpno.length - 5;
                for (let i = 0; i < starLength; i++) {
                  star += "*";
                }
                uatpno = star + uatpno.substr(uatpno.length - 5);
              } else {
                let star = "";
                let starLength = uatpno.length - 2;
                for (let i = 0; i < starLength; i++) {
                  star += "*";
                }
                uatpno = star + uatpno.substr(uatpno.length - 2);
              }
              that.costCenterName += "-" + uatpno;
            }
          } else {
            that.costCenterName = that.costCenterid;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //成本中心下拉改变事件
    CostCenterChange(val) {
      if (val == 0) {
        this.costCenterid = 0;
        this.uatpCardNo = "";
        this.uatpCardValidDate = "";
        this.uATPSupplierAndModel = "";
        this.costCenterName = "";
        return;
      }
      let arr = this.CostCenterList.filter((p) => p.id == val);
      if (arr.length > 0) {
        let item = arr[0];
        if (
          Object.prototype.hasOwnProperty.call(
            this.$objBaseInfo,
            "posCostCenterModel"
          )
        ) {
          let posCostCenterModel = this.$objBaseInfo.posCostCenterModel;
          this.costCenterid = item.id;
          this.uatpCardNo = item.uatpno;
          this.uatpCardValidDate = "";
          this.uATPSupplierAndModel = "";
          if (posCostCenterModel.isuatp == 1) {
            if (this.uatpCardNo == "") {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t(
                "BOOKING.CostCenterUATPTitle1"
              );
            } 
            else {
              this.GetUATPDetails();
            }
          } 
          else {
            if (this.uatpCardNo != "") {
              this.GetUATPDetails();
            }
          }
        }
      }
    },
    //信用卡有效期转换
    toValidate(validate) {
      if (validate) {
        //当年年份前两个字符
        const yyF = new Date().getFullYear().toString().substr(0, 2);
        if (validate.toString().length == 4) {
          //时间格式 MMYY
          const yyyyF = yyF + validate.toString().substr(2, 2);
          const mmF = validate.toString().substr(0, 2);
          return yyyyF + "-" + mmF + "-" + "01";
        } else if (
          validate.toString().length == 5 &&
          validate.toString().indexOf("/") > -1
        ) {
          //时间格式 MM/YY
          const dateArr = validate.split("/");
          return yyF + dateArr[1] + "-" + dateArr[0] + "-" + "01";
        } else if (
          //时间格式 yyyy-MM-ddThh:mm:ss.000Z
          validate.toString().indexOf("T") > -1
        ) {
          let shortDate = validate.toString().substr(0, 10);
          return shortDate;
        } else {
          console.log("信用卡有效期：", validate);
        }
      } else {
        console.log("信用卡有效期：", validate);
        return validate;
      }
    },
    //获取成本中心list
    GetCostCenterList() {
      let Params = {
        params: {
          customerCode: this.$objBaseInfo.customerCode,
          agentId: this.OrderData.orderInfo.bookingAgent[0].userId,
          gustId: this.OrderData.orderInfo.guestInfo[0].userId,
          type: this.costCenterType,
        },
      };
      console.log(this.OrderData.orderInfo);
      let that = this;
      this.CostCenterList = [];
      getCostCenter(Params)
        .then((res) => {
          if (res.code == 200) {
            let arr = res.data;
            that.CostCenterList = arr;
            if (
              Object.prototype.hasOwnProperty.call(
                that.$objBaseInfo,
                "posCostCenterModel"
              )
            ) {
              let posCostCenterModel = that.$objBaseInfo.posCostCenterModel;
              if (posCostCenterModel.isopen == 0) {
                return; //代表关闭成本中心
              }
              if (arr.length == 0) {
                that.confirmFlag = true;
                that.confirmMsg = that.$t("BOOKING.CostCenterTitle2");
                return;
              }
              // else
              // {
              //   that.costCenteroptions = that.CostCenterList.slice(0,1);
              // }
              // if(arr.length>0)
              // {
              //   let costCenter_arr=arr.filter(p=>p.id==that.costCenterid);
              //   if(costCenter_arr.length>0)
              //   {
              //     that.costCenterName=costCenter_arr[0].costName;
              //   }
              // }
            }
          } else {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("BOOKING.CostCenterTitle2");
          }
        })
        .catch(function (error) {
          that.confirmFlag = true;
          that.confirmMsg = that.$t("BOOKING.CostCenterTitle2");
        });
    },
    CostCenterloadMore(val) {
      // val是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      if (this.costCenterrangeNumber > this.CostCenterList.length) {
        return;
      }
      return () => (this.costCenterrangeNumber += 50); // 每次滚动到底部可以新增条数  可自定义
    },
    // 下拉框出现时，调用过滤方法
    visibleChange(flag) {
      if (flag) {
        this.filterMethod();
      }
    },
    // 筛选方法
    filterMethod: _debounce(function (filterVal) {
      if (filterVal) {
        let filterArr = this.CostCenterList.filter((item) => {
          return item.costName.includes(filterVal);
        });
        this.costCenteroptions = filterArr;
      } else {
        this.costCenteroptions = this.CostCenterList;
      }
    }, 500),
  },
  directives: {
    "el-select-loadmore": (el, binding) => {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.colorRed {
  color: red;
}
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .order_confirm_panel {
    background-color: #fff;
    padding: 1.3rem;
    font-size: 1.4rem;

    &.spacing {
      margin-bottom: 1.3rem;
    }

    .span_icon:not(:last-child) {
      height: 100%;
    }

    svg {
      margin-right: 1rem;
      flex: 1;
    }

    .confirm_text {
      font-size: 1.8rem;
      height: 2.8rem;
      line-height: 2.8rem;
    }
  }

  .panel_underline_title {
    border-bottom: 0.2rem solid $btn-bg-color;
    padding-bottom: 1.2rem;
    font-weight: bold;
  }

  .lable_value_review {
    width: 90%;
    height: 2.7rem;
    line-height: 2.7rem;
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
  }

  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1.5rem;
      color: $text-fill-color;
    }

    ::v-deep .el-input__inner {
      height: 2.7rem;
      line-height: 2.7rem;
    }
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .order_confirm_panel {
    background-color: #fff;
    padding: 1.3rem;
    font-size: 1.4rem;

    &.spacing {
      margin-bottom: 1.3rem;
    }

    .span_icon:not(:last-child) {
      height: 100%;
    }

    svg {
      margin-right: 1rem;
      flex: 1;
    }

    .confirm_text {
      font-size: 1.8rem;
      height: 2.8rem;
      line-height: 2.8rem;
    }
  }

  .panel_underline_title {
    border-bottom: 0.2rem solid $btn-bg-color;
    padding-bottom: 1.2rem;
    font-weight: bold;
  }

  .lable_value_review {
    width: 90%;
    height: 2.7rem;
    line-height: 2.7rem;
    background: $bg-color;
    border-radius: 0.2rem;
    padding: 0 1.3rem;
  }

  .form-label-field {
    ::v-deep .el-form-item__label {
      font-size: 1.4rem;
      height: 2rem;
      line-height: 2rem;
      margin-top: 1.5rem;
      color: $text-fill-color;
    }

    ::v-deep .el-input__inner {
      height: 2.7rem;
      line-height: 2.7rem;
    }
  }
}
</style>